import { Link, useNavigate } from "react-router-dom";
import ChevronDown from "@assets/svg/ChevronDown";
import PlusIcon from "@assets/svg/PlusIcon";
import SearchIcon from "@assets/svg/SearchIcon";
import { getCandidates } from "@endpoints/candidate.service";
import { useEffect, useState } from "react";
import Spinner from "@components/Spinner/Spinner";
import { setCandidates } from "@store/actions/candidate.action";
import { useDispatch, useSelector } from "react-redux";
import { candidateStatus } from "@utils/constants";

const ItemCard = ({ item, index }) => {
  return (
    <Link
      to={`/contacts/edit-candidate/${item?._id}`}
      className={`grid grid-cols-[1fr_1fr_0.7fr_0.5fr] py-3 hover:bg-gray-50 cursor-pointer ${
        index !== 0 ? "border-t" : ""
      }`}
    >
      <div className="flex items-center gap-3 pl-3">
        <div className="h-4 w-4 border rounded-sm" />
        <span className="flex font-medium text-xs text-charcoal">
          {item?.firstName} {item?.lastName}
        </span>
      </div>
      <span className="flex font-medium text-xs text-charcoal">
        {item?.jobTitle}
      </span>
      <span className="flex italic text-xs text-secondary">{item?.status}</span>
      <span className="flex text-xs text-light-black">{item?.refNo}</span>
    </Link>
  );
};

const CandidateSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { candidates } = useSelector((state) => state?.candidate);
  const [loading, setLoading] = useState(candidates?.length === 0);

  useEffect(() => {
    getCandidates({
      status: candidateStatus.CONTRACTED,
    })
      .then((response) => {
        const { success, data } = response;
        if (success) {
          dispatch(setCandidates(data));
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {/* Search and filter section */}
      <div className="flex items-center justify-between bg-[#F1F5F9] p-1 rounded-md my-4">
        <div className="flex items-center h-full gap-3">
          {/* Input container */}
          <div className="bg-white rounded-md px-3 border flex items-center h-8">
            <input
              className="text-xs font-medium flex-1 outline-none h-full w-64"
              placeholder="Search by Name, Title or Ref number..."
            />
            <SearchIcon className="w-4 h-4" color="gray" />
          </div>
          <button className="flex items-center justify-center border bg-white rounded-md px-3 h-full gap-4">
            <label className="text-charcoal text-xs font-medium">
              Filter status
            </label>
            <ChevronDown className={"w-4 h-4"} fill={"#2e2e2e"} />
          </button>
        </div>
        <button
          onClick={() => navigate("/contacts/add-candidate")}
          className="flex items-center justify-center border bg-primary rounded-md px-2 py-1 gap-1 text-white font-semibold text-sm"
        >
          <PlusIcon className={"w-4 h-4"} fill={"white"} />
          Candidate
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-[1fr_1fr_0.7fr_0.5fr] border-b pb-2.5 mt-3">
            <span className="font-semibold text-xs text-charcoal pl-3">
              Candidate Name
            </span>
            <span className="font-semibold text-xs text-charcoal">
              Job Title
            </span>
            <span className="font-semibold text-xs text-charcoal">Status</span>
            <span className="font-semibold text-xs text-charcoal">Ref No.</span>
          </div>
          {/* ScrollArea  */}
          <div className="flex flex-col mt-2 max-h-fit overflow-y-scroll no-scrollbar">
            {candidates?.map((item, index) => {
              return <ItemCard key={item?._id} item={item} index={index} />;
            })}
          </div>
        </>
      )}
    </>
  );
};

export default CandidateSection;
